import { render, staticRenderFns } from "./BookingBan.vue?vue&type=template&id=3e287ebe&scoped=true"
import script from "./BookingBan.vue?vue&type=script&lang=js"
export * from "./BookingBan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e287ebe",
  null
  
)

export default component.exports